// extracted by mini-css-extract-plugin
module.exports = {"pageList":"PageList_pageList__vqRSP","ingress":"PageList_ingress__M1f5b","list":"PageList_list__GSjyQ","row":"PageList_row__89WxG","date":"PageList_date__zDIR0"};